class JobsController {
  constructor(DataService, $sce) {
    "ngInject";
    this.name = 'jobs';
    this.jobsData = [];

    let self = this;
    // DataService.getInternalJobs().then(function(jobs) {
    //   self.setJobsData(jobs.data);
    // });


    this.knackEmbedCode = $sce.trustAsHtml('<script type="text/javascript">app_id="67054ebb6ada14027c93e8c1";distribution_key="dist_2";</script><script type="text/javascript" src="https://loader.knack.com/67054ebb6ada14027c93e8c1/dist_2/knack.js"></script><div id="knack-dist_2">Loading...</div>');


  }

  setJobsData(jobs) {
    this.jobsData = jobs;
  }


  $onInit() {
    this.page = 1;
  }

  $onChanges(changes) {
  }

  pageUp() {
    this.page++;
  }

  pageDown() {
    this.page--;
  }


}

export default JobsController;



// WEBPACK FOOTER //
// ./app/components/jobs/jobs.controller.js